module.exports = __webpack_public_path__ + "img/security-info.e19a4cb3.svg";